import { ENDPOINTS } from "../../endpoints";

export enum SubscriptionType {
  FREE = 0,
  BASIC = 1,
  STANDARD = 2,
  PROFESSIONAL = 3,
  ENTERPRISE = 4,
}

export enum CycleType {
  MONTHLY = 1,
  QUARTERLY = 2,
  YEARLY = 3,
}

interface UpsellContent {
  title: string;
  description: string;
  initialOption: string;
  currentOption: string;
  priceDetails: string;
  ctaTextPrimary: string;
  ctaTextSecondary: string;
  declineText: string;
  upsellingToPlan: SubscriptionType;
  upsellingToCycle: CycleType;
}

export type UpsellPagesContent = {
  [key in CycleType]: {
    [key in SubscriptionType]?: UpsellContent | null;
  };
};

export type GetUserSubscriptionResponse = {
  plan: SubscriptionType;
  cycle: CycleType;
  cost: number;
  next_payment_date: string;
  last_payment_date: string;
  used_credits_per_month: number;
  total_credits_per_month: number;
  credits_amount: number;
  canceled: boolean;
  cancelation_date: string;
};

export const getUserSubscription = async (headers: {
  Authorization: string;
}): Promise<GetUserSubscriptionResponse> => {
  try {
    const response = await fetch(ENDPOINTS.SUBSCRIPTION, {
      method: "GET",
      headers: {
        ...headers,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to get user subscription: ${response.status} ${response.statusText}`
      );
    }

    const data = (await response.json()) as GetUserSubscriptionResponse;
    return data;
  } catch (error) {
    console.error("Error getting user subscription:", error);
    throw error;
  }
};
